module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTcwNy40IDYzOC44YTMyIDMyIDAgMCAxIDIyLjYgNTQuN2wtMTk0LjMgMTk0LjJhMzIgMzIgMCAwIDEtNDUuMyAwbC0xOTQuMi0xOTQuMmEzMiAzMiAwIDAgMSAyMi42LTU0LjdoMzg4LjZ6TTUzNS44IDEzNi4ybDE5NC4yIDE5NC4zYTMyIDMyIDAgMCAxLTIyLjYgNTQuN0gzMTguOGEzMiAzMiAwIDAgMS0yMi42LTU0LjdsMTk0LjMtMTk0LjJhMzIgMzIgMCAwIDEgNDUuMyAweiIgZmlsbD0iIzAiIHAtaWQ9IjMzMDQiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret sort-filled.svg
// module id = 0nud
// module chunks = 74